import { Injectable } from '@angular/core';

/*
  Generated class for the NotTranslatedProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NotTranslatedProvider {
  notTranslated(key: string) {
    // console.log('<SEM-TRADUCAO>', key + '</SEM-TRADUCAO>');
  }
}



// WEBPACK FOOTER //
// ./src/providers/not-translated/not-translated.ts